export const AVAILABLE_BALANCE_HOLD_EUR = 25;

export const getLedgerBalance = (balance: number | undefined | null): number => {
  if (balance === undefined || balance === null || !isFinite(balance)) {
    return 0;
  }
  return balance;
};

export const getAvailableBalanceFromLedger = (
  ledgerBalance: number | undefined | null,
): number => {
  const ledger = getLedgerBalance(ledgerBalance);
  if (ledger <= 0) {
    return 0;
  }
  return Math.max(0, ledger - AVAILABLE_BALANCE_HOLD_EUR);
};

/** Spendable balance for payments, transfers, and validations */
export const getSpendableBalance = getAvailableBalanceFromLedger;
